module.exports = __webpack_public_path__ + "static/img/xg2-1.242b7b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xg2-1.png
// module id = 736
// module chunks = 0